import {connect} from 'react-redux';

import {
  createContactFormAddContactFieldAction,
  createContactFormRemoveContactFieldAction,
  createContactFormUpdateFieldAsyncAction,
} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormActions';
import {CreateContactFormFieldTypesEnum} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormState';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {CreateContactInformationPhoneInput} from './createContactInformationPhoneInput';

/*
 * Props.
 */

interface CreateContactInformationPhoneInputContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CreateContactInformationPhoneInputContainerProps>()(
  ({panelId}) => ({
    onUpdatePhoneNumberAsync: (uid: string, value: string) =>
      createContactFormUpdateFieldAsyncAction(panelId, uid, value),
    onAddPhone: () =>
      createContactFormAddContactFieldAction(panelId, CreateContactFormFieldTypesEnum.PHONE_NUMBER),
    onRemovePhone: (uid: string) => createContactFormRemoveContactFieldAction(panelId, uid),
  }),
);

export const CreateContactInformationPhoneInputContainer = connect(
  null,
  mapDispatchToProps,
)(CreateContactInformationPhoneInput);
